/* unplugin-vue-components disabled */import { render } from "./templateDemo.vue?vue&type=template&id=9d48cede&scoped=true"
import script from "./templateDemo.vue?vue&type=script&lang=js"
export * from "./templateDemo.vue?vue&type=script&lang=js"

import "./templateDemo.vue?vue&type=style&index=0&id=9d48cede&scoped=true&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d48cede"]])

export default __exports__